import { useEffect } from 'react';
import type { RegistrarUsuarioRequest } from '../../api-client/usuarios/usuarios.api';
import UsuarioForm from '../../components/usuarios/UsuarioForm';
import { useUsuariosStore } from '../../stores/usuarios/usuarios.store';

const AgregarUsuario = () => {
  const { current: usuario, nuevo, registrar } = useUsuariosStore();

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarUsuarioRequest) => {
    return registrar(values);
  };

  return <UsuarioForm esAgregar={true} usuario={usuario} onSave={handleSave} />;
};

export default AgregarUsuario;
